import { Map } from 'immutable';
import GrammaPro from './model';
import {
  FETCH_GRAMMA_PRO_SUCCESS,
} from './actions';

export default function grammaPro(state = new Map({}), action) {
  switch (action.type) {
    case FETCH_GRAMMA_PRO_SUCCESS:
      return state.set(action.groupId, onSuccess(action.payload));
    default:
      return state;
  }
}

function onSuccess(response) {
  return response.reduce((map, item) => map.set(`${item.studentId}`,
      GrammaPro.create(item)), new Map());
}



// WEBPACK FOOTER //
// ./data/GrammaPro/reducer.js